import React, { useContext } from 'react'
import { Route } from 'react-router-dom'
import StoryFeed from './StoryFeed'
import Map from './Map'
import StoryPage from '../StoryPage'
import { makeStyles } from '@material-ui/styles'
import clsx from 'clsx'
import SearchPage from './SearchPage'
import MobileContext from '../context/MobileContext'

const drawerWidth = 240

const useStyles = makeStyles((theme) => {
  return {
    main: {
      flexGrow: 1,
      padding: theme.spacing(3),
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: 0,
    },
    mainShift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: drawerWidth,
    },
  }
})

export default function Main(mainProps) {
  const {
    app,
    drawerOpen,
    viewCollectionClicked,
    searchValue,
    tagClick,
    mapStyle,
    toggleProgressDialog,
    performSearch,
    exitedStoryFeedCollectionPage,
    resetSkip,
  } = mainProps

  const classes = useStyles()

  const Context = useContext(MobileContext)
  const isMobile = Context.isMobile

  const handleShowStory = (storyId) => {
    mainProps.history.push(`${mainProps.match.url}/story/${storyId}`)
  }

  return (
    <div
      className={clsx(classes.main, {
        [classes.mainShift]: drawerOpen && !isMobile, // not allowing content to shift when in mobile view due to content being squashed weirdly
      })}
    >
      <Route
        path={mainProps.match.url}
        render={(props) => (
          <StoryFeed
            {...props}
            {...mainProps}
            showStory={handleShowStory}
            viewCollectionClicked={viewCollectionClicked}
            exitedStoryFeedCollectionPage={exitedStoryFeedCollectionPage}
            resetSkip={resetSkip}
          />
        )}
      />
      <Route
        exact
        path={`${mainProps.match.url}/map`}
        render={(props) => (
          <Map
            {...props}
            {...mainProps}
            showStory={handleShowStory}
            viewStoryClicked={(story) => handleShowStory(story._id)}
          />
        )}
      />
      <Route
        exact
        path={`${mainProps.match.url}/story/:storyId`}
        render={(props) => (
          <StoryPage
            {...props}
            app={app}
            clickTag={tagClick}
            mapStyle={mapStyle} />
        )}
      />
      <Route
        exact
        path={`${mainProps.match.url}/search/:searchValue`}
        render={(props) => (
          <SearchPage
            {...props}
            {...mainProps}
            searchValue={searchValue}
            showStory={handleShowStory}
            performSearch={performSearch}
            toggleProgressDialog={toggleProgressDialog}
          />
        )}
      />
    </div>
  )
}
